import { createElement } from 'react';
import { Upload, Button } from '@alifd/next';
import { openNewPage } from '@/utils';
import cookie from 'js-cookie';
import request from '@/utils/request';
const Operations = ({ record, isDesign, queryFilesList, docId, selectedRows, documentPermissions, setEditRow, }) => {
    const viewable = record?.resDocPhyInfoDTO?.fileNm && !isDesign;
    const uploadable = !isDesign;
    const downloadable = record?.resDocPhyInfoDTO?.fileNm && !isDesign;
    const editable = record?.resDocPhyInfoDTO?.fileNm && !isDesign;
    const lockable = record?.resDocPhyInfoDTO?.fileNm && !isDesign;
    const unLockable = record?.resDocPhyInfoDTO?.fileNm && !isDesign;
    const deleteable = record?.docTypeId === '1001000' && !isDesign;
    const download = () => {
        const url = `/api/document/docDownLoad/${record?.bizDocListDtlId}`;
        openNewPage(url);
    };
    const lock = async () => {
        await request.put('/api/document/bizDoc/lock', { bizDocListDtlIds: [record?.bizDocListDtlId] });
        queryFilesList(docId);
    };
    const unLock = async () => {
        await request.put('/api/document/bizDoc/unLock', {
            bizDocListDtlIds: [record?.bizDocListDtlId],
        });
        queryFilesList(docId);
    };
    const del = async () => {
        await request.delete(`/api/document/bizDoc/${record?.bizDocListDtlId}`);
        queryFilesList(docId);
    };
    const matchPermission = (code) => {
        const permissionsHasOther = documentPermissions.find((item) => item?.documentTypeCode === 'OTHER');
        if (record.docTypeId === '1001000' && !permissionsHasOther) {
            return true;
        }
        return documentPermissions
            ?.find((item) => item?.documentTypeCode === record?.docTypeNumber)
            ?.permissions?.includes(code);
    };
    const edit = () => {
        const { origin } = location;
        open(`${origin}/office/editor/?docId=${record?.bizDocListDtlId}&docName=${record?.resDocPhyInfoDTO?.fileNm}&docType=${record?.docformat}&key=${record?.bizDocListDtlId}`);
        setEditRow(record?.bizDocListDtlId);
    };
    const view = () => {
        const { origin } = location;
        open(`${origin}/office/editor/?docId=${record?.bizDocListDtlId}&docName=${record?.resDocPhyInfoDTO?.fileNm}&docType=${record?.docformat}&key=${record?.bizDocListDtlId}`);
    };
    return (createElement("div", { style: { display: 'flex', justifyContent: 'center', columnGap: 10 } },
        matchPermission('VIEW') && (createElement(Button, { text: true, type: "primary", disabled: !viewable, onClick: view }, "\u67E5\u770B")),
        matchPermission('UPLOAD') && (createElement(Upload, { action: "/api/document/docUpLoad", data: { bizDocListDtlId: record?.bizDocListDtlId }, headers: {
                Authorization: cookie.get('Authorization'),
            }, name: "multipartFile", onSuccess: () => queryFilesList(docId), accept: ".doc,.docx", disabled: !uploadable },
            createElement(Button, { text: true, type: "primary" }, "\u4E0A\u4F20"))),
        matchPermission('DOWNLOAD') && (createElement(Button, { text: true, type: "primary", disabled: !downloadable, onClick: download }, "\u4E0B\u8F7D")),
        matchPermission('EDIT') && (createElement(Button, { text: true, type: "primary", disabled: !editable, onClick: edit }, "\u7F16\u8F91")),
        matchPermission('LOCK') && (createElement(Button, { text: true, type: "primary", disabled: !lockable, onClick: lock }, "\u9501\u5B9A")),
        matchPermission('UNLOCK') && (createElement(Button, { text: true, type: "primary", disabled: !unLockable, onClick: unLock }, "\u89E3\u9501")),
        matchPermission('DELETE') && (createElement(Button, { text: true, type: "primary", disabled: !deleteable, onClick: del }, "\u5220\u9664"))));
};
export default Operations;
